import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

const initialState: any = {
  menuPlanReport: [],
  loading: false,
  error: null,
};

export const fetchItemInitiateMenuPlanReport = createAsyncThunk(
  'ItemInitiateMenuPlanReport/fetchItemInitiateMenuPlanReport',
  async (payload) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/ItemWisePlanning/InitiateMenuPlanItemWise/GetItemWiseInitiateMenuPlanReport`, payload);
    return response?.data;
  }
);

const itemInitiateMenuPlanReportSlice = createSlice({
  name: 'ItemInitiateMenuPlanReport',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchItemInitiateMenuPlanReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchItemInitiateMenuPlanReport.fulfilled, (state, action) => {
        state.loading = false;
        state.menuPlanReport = action.payload; // Assuming the payload is an array of menu plans
      })
      .addCase(fetchItemInitiateMenuPlanReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default itemInitiateMenuPlanReportSlice.reducer;
